jQuery(document).ready(function () {
	populateCurrentDateTime();
});

function populateCurrentDateTime() {
	var now = new Date();

	var year = now.getFullYear();
	var month = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based
	var day = String(now.getDate()).padStart(2, '0');
	var hours = String(now.getHours()).padStart(2, '0');
	var minutes = String(now.getMinutes()).padStart(2, '0');
	var seconds = String(now.getSeconds()).padStart(2, '0');

	jQuery('#year-now').text(year);
	jQuery('#month-now').text(month);
	jQuery('#day-now').text(day);
	jQuery('#time-now').text(hours + ':' + minutes + ':' + seconds);
}
